import React from 'react';
import { Button } from '@wix/wix-base-ui';
import type { IMenuItem } from '#packages/baseUI';
import type { MenuItem as DSMenuItem } from 'types/documentServices';
import { translate } from '#packages/i18n';
import { TRANSLATIONS_MAP } from './translations';
import _ from 'lodash';
export const SLOT_PREFIX = 'SLOT';

export const createSlotContainerItem = (
  parentItem: DSMenuItem,
  edit?: (item: DSMenuItem) => void,
): IMenuItem => ({
  type: 'BasicMenuItem',
  id: `${parentItem.id}__${SLOT_PREFIX}`,
  label: translate(TRANSLATIONS_MAP.ITEM.CONTAINER.label),
  isVisible: true,
  isVisibleMobile: false,
  symbol: 'containerPageType',
  customButton: (
    <Button
      className="btn-confirm-secondary btn-sm menu-manage-panel__slot-custom-button"
      onClick={() => edit?.(parentItem)}
    >
      {translate(TRANSLATIONS_MAP.ITEM.CONTAINER.edit)}
    </Button>
  ),
  items: [],
  blockDrag: true,
  blockDrop: true,
});

export const createSlotPlaceholderItem = (
  parentItem: DSMenuItem,
): IMenuItem => ({
  type: 'BasicMenuItem',
  id: `${parentItem.id}__${SLOT_PREFIX}`,
  label: translate(TRANSLATIONS_MAP.ITEM.SLOT_PLACEHOLDER.label),
  isVisible: true,
  isVisibleMobile: false,
  items: [],
  blockDrag: true,
  blockDrop: false,
  isPlaceholder: true,
});

export const isSlotItem = (item: DSMenuItem) => isSlotItemById(item.id);

export const isSlotItemById = (id: string) => id.endsWith(SLOT_PREFIX);

export const isSlotParentItem = (item: Partial<DSMenuItem>) =>
  _.has(item, 'slot');

export const getSlotItemParentId = (itemId: string) =>
  itemId.replace(`__${SLOT_PREFIX}`, '');
